module.exports = __webpack_public_path__ + "static/media/s11.12f2f51d.png";